import "./modules/common";
// import Ecommerce from "spiritweb.packages.ecommerce";
import VueApp from "~/Scripts/new/vueApp";
import Faqs from "~/Components/FAQs/Faqs.vue";

new VueApp( {
  name: "faqs",
  components: {
    Faqs,
  },
} );
